module.exports = __webpack_public_path__ + "static/img/overwrite.2b739a50.svg";